<template>
  <div
    class="workflow-page"
    :class="{ mobile: isMobile() }"
    data-cy="workflow-page"
  >
    <AccessHandler
      :requiredRoleGroups="roleGroups"
      @accessChanged="(a: boolean) => (hasAccess = a)"
    />
    <MasterPage>
      <template v-if="isMobile() && hasAccess" v-slot:content>
        <WorkflowMobileTabs />
        <GlobalFooter />
      </template>
      <template v-else-if="hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">Workflow Overview</h1>
        </header>
        <div class="workflow-container">
          <WorkflowView />
        </div>
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import GlobalFooter from "../GlobalFooter.vue";
import WorkflowView from "./WorkflowView.vue";
import {
  IngredientsAppGroup,
  ProductAppGroup,
  type RoleGroup,
} from "@/shared/access/RoleGroups";
import { ref } from "vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { isMobile } from "@/shared/helpers/mobileHelper";
import WorkflowMobileTabs from "./WorkflowMobileTabs.vue";

const roleGroups = [
  {
    roles: [...IngredientsAppGroup.roles, ...ProductAppGroup.roles],
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.workflow-page.mobile {
  background: #f8fafb;
}
.workflow-container {
  margin: 10px 30px 30px;
  padding: 0;
  width: auto;
}
</style>
